import React, { useContext, useEffect, useState } from 'react';
import * as R from 'ramda';
import ExplainerPanel from '../../common/components/ExplainerPanel/ExplainerPanel';
import {
  ExplainerPanelSubDescription,
  ExplainerPanelSubDescriptionIcon,
} from '../../common/components/ExplainerPanel/ExplainerPanelProps';
import { Provider } from '../../config';
import { ValidationContext } from '../../providers/ValidationContext';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';
import { GatekeeperNetworkServiceContext } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';
import { getGknValue } from '../../providers/GatekeeperNetworkService/utils';
import { RequiredDeclarations } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceData';
import useTermsLinks from '../../common/hooks/useTermsLinks';

function DocumentExplainerScreen(): JSX.Element {
  const {
    initialized,
    provider,
    selectProvider,
    navigateToNextFlow,
  } = useContext(FlowConfigContext);
  const { termsLink, privacyPolicyLink, biometricPolicyLink, setAcceptedAllTerms, hasAcceptedAllTerms } = useTermsLinks();

  const { gknServiceData } = useContext(GatekeeperNetworkServiceContext);

  const { isWebFlowEnabled } = useContext(ValidationContext);
  const isAppFlowStage =
    (process.env.REACT_APP_STAGE || 'unknown') === 'e2e' ||
    (process.env.REACT_APP_STAGE || 'unknown') === 'preprod_e2e' ||
    (process.env.REACT_APP_STAGE || 'unknown') === 'mock';
  const isAppFlowEnabled = isWebFlowEnabled && isAppFlowStage;

  useEffect(() => {
    if (!provider || !hasAcceptedAllTerms()) {
      return;
    }

    navigateToNextFlow();
  }, [provider, hasAcceptedAllTerms]);

  const handleStartVerificationClick = async () => {
    setAcceptedAllTerms();
    selectProvider(Provider.WEB);
  };

  const handleUseCivicAppClick = async () => {
    setAcceptedAllTerms();
    selectProvider(Provider.SIP);
  };

  const subDescriptions: ExplainerPanelSubDescription[] = [
    {
      title: 'screens.documentPass.explainer.selfieExplanation',
      icon: ExplainerPanelSubDescriptionIcon.FACE_AUTH,
    },
    {
      title: 'screens.documentPass.explainer.governmentPhotoIdExplanation',
      icon: ExplainerPanelSubDescriptionIcon.DOCUMENT,
    },
  ];

  return (
    <ExplainerPanel
      title="common.explainer.title"
      subDescriptionsWithIcon={subDescriptions}
      onPrimaryButtonPressed={isWebFlowEnabled ? handleStartVerificationClick : handleUseCivicAppClick}
      onSecondaryButtonPressed={handleUseCivicAppClick}
      showSecondaryButton={isAppFlowEnabled}
      termsLink={termsLink}
      privacyPolicyLink={privacyPolicyLink}
      biometricPolicyLink={biometricPolicyLink}
      dataTestId="IDENTITY_VERIFICATION_HEADER"
    />
  );
}
export default withRouteAnalytics(DocumentExplainerScreen, Screens.EXPLAINER_DOCUMENT);
